// ═══════════════════════════════════════════════════════════════
// ██  i18n  ██  Système bilingue FR / EN
// ═══════════════════════════════════════════════════════════════
// Usage :
//   data-i18n="key"              → traduit textContent
//   data-i18n-aria="key"         → traduit aria-label
//   data-i18n-placeholder="key"  → traduit placeholder
//   data-i18n-title="key"        → traduit title attribute
//   data-i18n-content="key"      → traduit content attribute (meta)
// ═══════════════════════════════════════════════════════════════

const TRANSLATIONS = {
  fr: {
    // ── Nav ───────────────────────────────────────────────────
    "nav.playground": "Playground",
    "nav.lang-label": "Langue",

    // ── Hero ──────────────────────────────────────────────────
    "hero.tagline": "Ce que l'œil retient.",

    // ── About ─────────────────────────────────────────────────
    "about.label": "[ À propos ]",
    "about.aria": "À propos",
    "about.p1": "Bienvenue ! Je m'appelle Maxime Cordy, Interactive Media Designer basé en Valais. Passionné par le design graphique, la photographie, la vidéo et le développement frontend, j'aime créer des projets qui allient esthétique et fonctionnalité.",
    "about.p2": "De la première idée jusqu'au résultat final, j'accorde une attention particulière aux détails pour concevoir des expériences simples, efficaces et soignées. Curieux de nature, je vois chaque nouveau projet comme une occasion d'apprendre, d'expérimenter et de continuer à évoluer.",
    "about.p3": "Ayant auparavant obtenu un CFC de boulanger-pâtissier-confiseur, j'ai développé un véritable esprit d'équipe ainsi qu'un goût prononcé pour la création et le partage. J'accorde une grande importance à la collaboration, à l'échange et à la qualité des relations humaines.",
    "about.cta.contact": "[ Contact ]",
    "about.cta.cv": "[ CV ]",
    "about.cv.download": "[ Télécharger le CV ]",

    // ── Statement ─────────────────────────────────────────────
    "statement.line1": "J'aime créer et partager, apprendre et découvrir,",
    "statement.line2": "raconter des histoires et les illustrer.",
    "statement.cta": "[ Travaillons ensemble ]",

    // ── Selected works ────────────────────────────────────────
    "works.label": "[ Travaux sélectionnés ]",
    "works.aria": "Travaux sélectionnés",
    "works.body": "Au cours de mon apprentissage, j'ai eu l'occasion de concevoir et de réaliser des projets pour des agences ainsi que des mandats fictifs. Cette sélection rassemble quelques-unes de mes réalisations les plus marquantes. N'hésitez pas à les découvrir dans le Playground.",
    "works.cta": "[ Playground ]",

    // ── Closing note ──────────────────────────────────────────
    "closing.title": "Merci d'être arrivé jusqu'ici.",
    "closing.sub": "J'aimerais travailler avec vous,<br>mais vous le voulez vous ?",
    "closing.body1": "Je suis actuellement en recherche de stage ou CDI. Ouvert à travailler en agence comme pour du privé.",
    "closing.body2": "Une idée en tête ? Un produit à mettre en avant ? Une place à promouvoir dans votre entreprise ? Je suis déterminé à découvrir.",
    "closing.cta.contact": "[Contact]",
    "closing.cta.cv": "[CV]",

    // ── Footer ────────────────────────────────────────────────
    "footer.nav.title": "Navigation",
    "footer.disciplines.title": "Disciplines",
    "footer.disciplines.video": "Vidéo",
    "footer.disciplines.communication": "Communication",
    "footer.contact.title": "Contact",
    "footer.contact.location": "Valais, Suisse",
    "footer.socials.title": "Socials",
    "footer.bar.copy": "© 2026 Maxime Cordy. Tous droits réservés.",
    "footer.bar.credit": "Ce site a été créé en 2026 sur VS Code, avec l'aide de Claude AI",
    "footer.bar.made": "Design & Développement — Maxime Cordy",

    // ── Panel ─────────────────────────────────────────────────
    "panel.close": "Fermer",
    "panel.prev": "Précédent",
    "panel.next": "Suivant",
    "panel.category": "Catégorie",
    "panel.skills": "Skills",
    "panel.year": "Année",
    "panel.presentation": "Présentation",
    "panel.description": "Description",
    "panel.fallback": "Description à remplir.",

    // ── Loader ────────────────────────────────────────────────
    "loader.text": "Chargement",
    "loader.aria": "Chargement",

    // ── Playground page ───────────────────────────────────────
    "pg.welcome": "Bienvenue, ici tu découvriras toutes mes créations !",
    "pg.hint": "Clique sur un projet pour en découvrir les détails.",
    "pg.filter.all": "Tout",
    "pg.filter.video": "Vidéo",
    "pg.filter.photo": "Photo",
    "pg.filter.web": "Web",
    "pg.footer.title": "C'est tout pour l'instant.",
    "pg.footer.sub": "Aidez moi à agrandir ce portfolio, ",
    "pg.footer.cta": "Travaillons ensemble →",
    "pg.footer.top": "↑ Revenir en haut",
    "pg.count.singular": "projet",
    "pg.count.plural": "projets",

    // ── Meta ──────────────────────────────────────────────────
    "meta.title.home": "Maxime Cordy — Interactive Media Designer",
    "meta.desc.home": "Portfolio de Maxime Cordy, designer interactif passionné par l'image, le mouvement et les interfaces. Projets web, vidéo et photo.",
    "meta.title.playground": "Playground — Maxime Cordy",
    "meta.desc.playground": "Tous les projets de Maxime Cordy — web, vidéo, photo et design graphique.",

    // ── Project links ─────────────────────────────────────────
    "link.website": "Voir le site",
    "link.figma": "Voir sur Figma",
    "link.youtube": "Voir sur YouTube",
    "link.github": "GitHub",
  },

  en: {
    // ── Nav ───────────────────────────────────────────────────
    "nav.playground": "Playground",
    "nav.lang-label": "Language",

    // ── Hero ──────────────────────────────────────────────────
    "hero.tagline": "What the eye remembers.",

    // ── About ─────────────────────────────────────────────────
    "about.label": "[ About ]",
    "about.aria": "About",
    "about.p1": "Hi ! I'm Maxime Cordy, an Interactive Media Designer based in Valais, Switzerland. With a passion for graphic design, photography, video and front-end development, I love building projects that balance aesthetics and functionality.",
    "about.p2": "From the first idea to the final result, I pay close attention to detail to craft experiences that are clean, efficient and considered. Naturally curious, I see every new project as an opportunity to learn, experiment and keep growing.",
    "about.p3": "I started out as a trained baker-pastry chef, which gave me a strong team spirit and a genuine love of craft and sharing. I place great value on collaboration, open exchange and the quality of human relationships.",
    "about.cta.contact": "[ Contact ]",
    "about.cta.cv": "[ CV ]",
    "about.cv.download": "[ Download CV ]",

    // ── Statement ─────────────────────────────────────────────
    "statement.line1": "I love to create and share, to learn and discover,",
    "statement.line2": "to tell stories and bring them to life.",
    "statement.cta": "[ Let's work together ]",

    // ── Selected works ────────────────────────────────────────
    "works.label": "[ Selected works ]",
    "works.aria": "Selected works",
    "works.body": "Throughout my training I had the opportunity to design and produce projects for agencies as well as fictional briefs. This selection gathers some of my most significant pieces. Feel free to explore more in the Playground.",
    "works.cta": "[ Playground ]",

    // ── Closing note ──────────────────────────────────────────
    "closing.title": "Thanks for making it this far.",
    "closing.sub": "I'd love to work with you —<br>but do you feel the same ?",
    "closing.body1": "I'm currently looking for an internship or a full-time position. Open to working in an agency or directly with a client.",
    "closing.body2": "Got an idea? A product to promote? A role to fill in your team? I'm eager to find out.",
    "closing.cta.contact": "[Contact]",
    "closing.cta.cv": "[CV]",

    // ── Footer ────────────────────────────────────────────────
    "footer.nav.title": "Navigation",
    "footer.disciplines.title": "Disciplines",
    "footer.disciplines.video": "Video",
    "footer.disciplines.communication": "Communication",
    "footer.contact.title": "Contact",
    "footer.contact.location": "Valais, Switzerland",
    "footer.socials.title": "Socials",
    "footer.bar.copy": "© 2026 Maxime Cordy. All rights reserved.",
    "footer.bar.credit": "This site was built in 2026 using VS Code, with the help of Claude AI",
    "footer.bar.made": "Design & Development — Maxime Cordy",

    // ── Panel ─────────────────────────────────────────────────
    "panel.close": "Close",
    "panel.prev": "Previous",
    "panel.next": "Next",
    "panel.category": "Category",
    "panel.skills": "Skills",
    "panel.year": "Year",
    "panel.presentation": "Overview",
    "panel.description": "Description",
    "panel.fallback": "Description coming soon.",

    // ── Loader ────────────────────────────────────────────────
    "loader.text": "Loading",
    "loader.aria": "Loading",

    // ── Playground page ───────────────────────────────────────
    "pg.welcome": "Welcome — here you'll find all my work !",
    "pg.hint": "Click on a project to explore the details.",
    "pg.filter.all": "All",
    "pg.filter.video": "Video",
    "pg.filter.photo": "Photo",
    "pg.filter.web": "Web",
    "pg.footer.title": "That's all for now.",
    "pg.footer.sub": "Help me grow this portfolio, ",
    "pg.footer.cta": "Let's work together →",
    "pg.footer.top": "↑ Back to top",
    "pg.count.singular": "project",
    "pg.count.plural": "projects",

    // ── Meta ──────────────────────────────────────────────────
    "meta.title.home": "Maxime Cordy — Interactive Media Designer",
    "meta.desc.home": "Portfolio of Maxime Cordy, an interactive media designer passionate about image, motion and interfaces. Web, video and photo projects.",
    "meta.title.playground": "Playground — Maxime Cordy",
    "meta.desc.playground": "All of Maxime Cordy's projects — web, video, photo and graphic design.",

    // ── Project links ─────────────────────────────────────────
    "link.website": "View website",
    "link.figma": "View on Figma",
    "link.youtube": "View on YouTube",
    "link.github": "GitHub",
  },
};

// ── Project descriptions EN ───────────────────────────────────
export const PROJECT_DESC_EN = {
  "La Galerie des Souvenirs": "La Galerie des Souvenirs was, by far, the most ambitious project I completed during my training. Known as the S6 Project — the sixth and final semester — it ran over several months around the shared theme of [Out of Control]. I chose to build an interactive museum website telling the story of artist William Utermohlen and his gradual loss of control as Alzheimer's disease took hold. The site traces his full life: from birth to death, through the different chapters of his career, all the way to the appearance of his first symptoms. I'm extremely proud of this project, which earned me a distinction at the final presentation. I also plan to submit it to Awwwards and SiteInspire in 2027. A physical stand and a poster were also produced for the occasion, to present our work to agencies, private clients and fellow students at an open evening dedicated to the S6 project.",
  "Vitamin Well": "This video holds a special place for me — both for its quality and for the effort it took to make it happen. The brief was to produce a fictional advertisement for the vitamin drink brand Vitamin Well. The film puts you right in the middle of a run: the effort, the fatigue, the well-earned hydration at the end. The whole piece is wrapped in a cold, overcast atmosphere that reinforces the sense of pushing your limits. Credits: Andréa Iacoviello, Magnolia Occhipinti, Maxime Cordy",
  "Ciné Gusto": "Ciné Gusto was my final major project at the end of my training. For this TPI exam, I had to choose and produce three deliverables to promote a fictional festival blending cinema, gastronomy and transculturalism. I designed a one-page landing page mockup, a digital signage video for the festival's physical locations, and an app icon for a VOD platform bringing together all the films and recipes from the festival. After a marketing analysis, I developed a minimalist art direction to keep things sharp and direct. A halftone treatment on the film posters nods to cinema culture, while saturated-colour food packshots open up the appetite. The project was presented in a 30-minute session in front of industry experts. I'm satisfied with the outcome, though I would have liked more time to refine certain details. Credits: Maxime Cordy",
  "SEUL": "[SEUL] is a fictional short film created from start to finish with four classmates and one actor. The film was selected for the NiFFF (Neuchâtel International Fantastic Film Festival) and follows a man living alone in his chalet, isolated from all human presence, haunted by a strange force that torments him. It was shot in my family's chalet using professional equipment lent by my school, eikon. A single day of shooting was enough thanks to a detailed, complete storyboard. The edit was then divided between the four of us, each responsible for a specific area: sound, music, colour grading, cutting or After Effects work.",
  "Muay Thaï": "My friend Nico kindly agreed to let us film a documentary in the gym where he trains Muay Thai. The film follows him through an entire training session, intercut with a face-to-camera interview in which he talks about his connection to the sport, what he loves about it, and invites others to give it a try. Credits: Magnolia Occhipinti, Maxime Cordy, Nicola Cleusix",
  "Sabre": "Sabre is a graphic novel by Éric Feres about a very unusual little tiger. The fictional brief from Eikon asked us to create a storytelling website to promote the book. Together with two colleagues, we reimagined the story to convey both information and emotion to anyone discovering the site — putting the work firmly in the spotlight. It took a lot of thinking, reading and coding to get there! Credits: Andréa Iacoviello, Tilio Pezzoli, Maxime Cordy",
  "Harlem": "This site is a bit of an outlier. For an art history project, we had to create an interactive medium presenting five artworks with a common thread. Given tight time constraints, I first designed a landing page mockup in Figma, then decided to use Claude Code and Claude (in Cowork mode) to build an infinite-scroll site made up of several in-depth sections. Credits: Maxime Cordy",
  "Affiches": "Here are three posters I designed over the years. The first was my first professional commission — for the Juvenalia festival in Fribourg — which taught me to listen carefully to a client's vision and stay in close contact throughout the creative process. A great experience. The other two were produced as part of my coursework: one for the Les Georges festival, also in Fribourg, and one informational poster about the languages spoken in Switzerland. That last one features a photograph taken by a classmate and myself, showing a young child calling out the different languages through childlike drawings. Credits: Maxime Cordy",
  "Retraite": "For this photo series on the theme of retirement, my grandmother kindly agreed to pose during her favourite sporting activities. The goal was to portray an active retiree and show that a fulfilling retirement can go hand in hand with energy, movement and passion. Credits: Maxime Cordy, Micheline Nanchen",
  "Jaguar": "This was the first video I ever shot at school — a fictional advertisement promoting two Jaguar Type E cars, roaming different environments across Switzerland, desperately searching for each other before finally meeting at the end. Two days of outdoor shooting with two vintage cars, made with my father and my girlfriend. Credits: Maxime Cordy, Walter Cordy",
  "Bota Bota": "This graphic design project gave me the chance to dive into a full fictional rebrand of the Fribourg Botanical Garden. The idea was to build on the existing identity and bring it into the modern era, with the goal of attracting more visitors. We started by defining an appropriate visual style, then moved on to producing the various mockups. The inspiration for the logo came from looking at the garden's shape on Google Maps — its form was perfect for creating a mark that links the symbolism of nature (the rings of a tree trunk) with the carefully planned layout of the botanical garden. Credits: Maxime Cordy, Tilio Pezzoli",
  "Is There Anybody Out There ?": "A music video made for the Pink Floyd song \"Is There Anybody Out There?\" from the album The Wall. The film follows a tormented young man, trapped inside his own mind, wondering whether there is still anyone out there. Alongside this, footage of nature entirely devoid of human life illustrates a silent outer world, blurring the line between reality, perception and the character's possible madness. Credits: Maxime Cordy, Tilio Pezzoli, Andréa Iacoviello",
  "SABRE Animation": "This animation is the follow-up to the SABRE web project. It picks up the site's visual universe and transforms it into an immersive animated sequence that blends motion design with a strong brand identity. The project explores the narrative possibilities of animation as part of a brand identity system. Credits: Maxime Cordy, Tilio Pezzoli, Andréa Iacoviello",
  "Croatie": "I love photography — whether it's nature, studio or portrait work. These shots were taken in Croatia with my Sony A6700 on the island of Komiža. The aim was to create a series of images capturing a beach holiday with a nostalgic feel. Credits: Maxime Cordy",
};

// ── Project link label map ────────────────────────────────────
const LINK_LABEL_MAP = {
  fr: {
    "Voir le site": "link.website",
    "Voir sur Figma": "link.figma",
    "Voir sur YouTube": "link.youtube",
    "GitHub": "link.github",
  },
  en: {
    "View website": "link.website",
    "View on Figma": "link.figma",
    "View on YouTube": "link.youtube",
    "GitHub": "link.github",
  },
};

// ── Core ──────────────────────────────────────────────────────
let currentLang = localStorage.getItem("lang") || "fr";

export function t(key) {
  return (TRANSLATIONS[currentLang] || TRANSLATIONS.fr)[key] || key;
}

export function getLang() { return currentLang; }

export function setLang(lang) {
  if (!TRANSLATIONS[lang]) return;
  currentLang = lang;
  localStorage.setItem("lang", lang);
  document.documentElement.lang = lang;
  applyTranslations();
  document.dispatchEvent(new CustomEvent("langchange", { detail: { lang } }));
}

// ── Apply all data-i18n attributes ───────────────────────────
export function applyTranslations() {
  const strings = TRANSLATIONS[currentLang] || TRANSLATIONS.fr;

  document.querySelectorAll("[data-i18n]").forEach((el) => {
    const key = el.dataset.i18n;
    if (strings[key] !== undefined) el.innerHTML = strings[key];
  });
  document.querySelectorAll("[data-i18n-aria]").forEach((el) => {
    const key = el.dataset.i18nAria;
    if (strings[key] !== undefined) el.setAttribute("aria-label", strings[key]);
  });
  document.querySelectorAll("[data-i18n-placeholder]").forEach((el) => {
    const key = el.dataset.i18nPlaceholder;
    if (strings[key] !== undefined) el.placeholder = strings[key];
  });
  document.querySelectorAll("[data-i18n-title]").forEach((el) => {
    const key = el.dataset.i18nTitle;
    if (strings[key] !== undefined) el.title = strings[key];
  });
  document.querySelectorAll("[data-i18n-content]").forEach((el) => {
    const key = el.dataset.i18nContent;
    if (strings[key] !== undefined) el.setAttribute("content", strings[key]);
  });

  // Page title
  const titleKey = document.body.dataset.titleKey;
  if (titleKey && strings[titleKey]) document.title = strings[titleKey];

  // Sync switcher buttons state
  document.querySelectorAll(".lang-btn").forEach((btn) => {
    btn.classList.toggle("active", btn.dataset.lang === currentLang);
    btn.setAttribute("aria-pressed", btn.dataset.lang === currentLang);
  });
}

// ── Switcher HTML helper ──────────────────────────────────────
export function createSwitcher() {
  const wrap = document.createElement("div");
  wrap.className = "lang-switcher";
  wrap.setAttribute("aria-label", "Language switcher");
  ["fr", "en"].forEach((l, i) => {
    if (i > 0) {
      const sep = document.createElement("span");
      sep.className = "lang-sep";
      sep.textContent = "·";
      sep.setAttribute("aria-hidden", "true");
      wrap.appendChild(sep);
    }
    const btn = document.createElement("button");
    btn.className = "lang-btn";
    btn.dataset.lang = l;
    btn.textContent = l.toUpperCase();
    btn.setAttribute("aria-pressed", l === currentLang);
    btn.addEventListener("click", () => setLang(l));
    if (l === currentLang) btn.classList.add("active");
    wrap.appendChild(btn);
  });
  return wrap;
}

// ── Translate a link label string ────────────────────────────
export function translateLinkLabel(frLabel) {
  // Find the key by the FR label, then return the current lang label
  const key = LINK_LABEL_MAP.fr[frLabel];
  if (!key) return frLabel;
  return t(key);
}

// ── Init ──────────────────────────────────────────────────────
export function initI18n() {
  document.documentElement.lang = currentLang;
  applyTranslations();
}
